const Database=

[
  {
    "home": "COVID-19",
    "data1": "What do we know?",
    "data2": "What do all the maps and charts mean?",
    "datac": "Questions this chart does NOT answer:",
    "data2q": "Questions this chart answers:",
    "data3": "How quickly has the virus spread around the world?",
    "data4": "Are we winning or losing the fight?",
    "data5": "When do you think this will all end?"
  },
  {
    "home": "Making sense of all the numbers",
    "data1": "Every day there are thousands of headlines with the latest figures on the coronavirus. For most readers the numbers are growing at such a dizzying rate that it's very easy to feel overwhelmed.\n\nIf there was ever a time where we needed clear and reliable data it's now.\n\nHow individuals and governments interpret and act upon this data will not only help us stay safe but will ultimately be necessary to ending the global coronavirus pandemic.",
    "data2": "The purpose of a map or chart is to take a lot of information and make it easily digestible. Different charts have different meanings. No single chart can communicate everything about how COVID-19 behaves. Even the choice of the x and y axis can give readers a very different understanding of the data.\n\nGenerally speaking, maps can tell you what's happening around the world right now, while charts tell you what's happened over time.\n\nBelow are a series of maps and charts from OurWorldInData.org - a comprehensive resource that aggregates data from various international sources. Use the built-in filters and tabs to select your country.",
    "datac": "Q. How many people were infected today?\nA. This map only shows you the number of people who tested positive today. This excludes everyone else who may have symptoms but were not tested.\n\nQ. Are countries with fewer reported cases doing well?\nA. It depends, if these countries are not sufficiently testing or sharing their data they may have a lot more undiagnosed cases. See the test rates chart below.",
    "data2q": "Q. How widespread is the virus?\nA. Click on the map and you'll see the number of new cases reported each day. Remember, this is lower than the actual number of people infected.\n\nQ. Which day had the most number of new cases?\nA. Technically it's the highest value on the y-axis but don't read too much into this. Once again, general trends matter more.",
    "data3": "The first reported coronavirus case was a 55-year-old individual from Hubei province, China on November 17, 2019.\n\nThe virus quickly spread around the region and then the world. On March 26, the US overtook China and currently has the highest number of confirmed cases worldwide.\n\nThe animation below shows how the virus spread globally. ",
    "data4": "The question on a lot of people's minds right now is how can we measure if things are getting better or worse each day?\n\nOne way is to compare the rolling averages. This allows you to see if the number of new infections this week was lower than than last week. ",
    "data5": null
  },
  {
    "home": "In this five part graphic series, Al Jazeera helps you filter through the headlines and charts behind the coronavirus.",
    "data1": "THERE IS A LOT OF UNCERTAINTY",
    "data2": null,
    "datac": "Q. How many total deaths have there been worldwide?\nA. You'd need to look at a cumulative chart to better answer this.\n\nQ. Why do certain countries have more deaths?\nA. Charts are not very good at answering the question \"why\".",
    "data2q": "Q. Are the number of deaths increasing or decreasing?\nA. To answer this you'll need to look at the overall trends. If the slope is moving upwards then deaths are increasing, if downwards then they are decreasing. Don't draw conclusions based on looking at daily changes on their own, these can differ based on how the data was collected the day before.\n\nQ. Which day had the most number of new cases?\nA. Technically it's the highest value on the y-axis but don't read too much into this. Once again, general trends matter more.",
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": "Published: 15 April 2020",
    "data1": "If you didn't know this already, the coronavirus numbers being reported are not facts. \n\nNo single dataset exactly represents the reality on the ground. Every day, thousands of healthcare workers, government agencies and researchers are each collecting, processing and sharing what they know about the virus. The goal is to gather the most reliable data that can help people understand the outbreak as it evolves.\n\nIn science, when we're uncertain about something, we get new evidence and update our beliefs. As countries continue to collect and share their experiences, the closer to reality we should get.  \n\nAl Jazeera, like many others, primarily uses the Johns Hopkins University Coronavirus dataset, which combines figures from the World Health Organization (WHO), the US Centers for Disease Control and Prevention (CDC), the European Centre for Disease Prevention and Control (ECDC) as well as several other local media and government sources. https://github.com/CSSEGISandData/COVID-19.",
    "data2": null,
    "datac": "Q. Are the number of tests increasing worldwide?\nA. There is no standardised global measurement for testing. Tests units vary significantly across countries so be careful when comparing data.",
    "data2q": "Q. Which countries are testing the most?\nA. Countries higher up on the list are testing more people relative to their populations. Normalising the data per 1,000 people is more meaningful than than showing absolute numbers.",
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": "Can we trust the data? How do I read these charts? How does my country rank? Are we winning or losing the fight? How long will this last?",
    "data1": "The most widely reported numbers are the number of confirmed cases, deaths, fatality rate, recoveries and active cases. We illustrate what these actually mean in the section below.",
    "data2": null,
    "datac": "Q. How long will the lockdowns last?\nA. The graphs show you seven-day rolling averages. These averages adjust the slope of the curve on a daily basis and are affected by real-world actions such as social-distancing and quarantines. Be careful not to naively extrapolate values today for what will happen in the future.",
    "data2q": "Q. Is my country getting better or worse?\nA. Select your country from the menu on the bottom left, if the graph is trending downwards then the rate of deaths is decreasing, if the graph is trending upwards then the rate is increasing.\n\nQ. Why is my country not included?\nA. This graph only shows countries that have reported at least five deaths.",
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "CONFIRMED CASES",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": null,
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "Confirmed cases tells us the number of people who have tested positive. One of the stealthiest characteristics of the coronavirus is that it can be spread with little to no symptoms. This means that the number of people worldwide who are actually infected is probably much higher than the official confirmed cases.\n\nIf you're not tested, you're not counted. \n\nViruses including COVID-19 tend to spread at an exponential rate which means they multiply really quickly. On March 6, the world had 100,000 confirmed cases, one month later this number was one million, and if the virus continues to grow at this rate, this number could reach 10 million by May.\n\nThat is why governments in many parts of the world have imposed nationwide lockdowns to slow down the rate of infection or \"flatten the curve\". ",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "CONFIRMED DEATHS",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": null,
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "Leading infectious disease experts have already warned that despite strict physical distancing measures the world could still face hundreds of thousands of deaths - if not millions.\n\nJust like confirmed cases, the actual number of deaths is almost certainly higher than what's being reported. Several reports have also emerged of undercounting. These include many cases where people are dying at home despite showing unmistakable COVID-19 symptoms.\n\nReporting deaths is a sensitive process.\n\nEvery country has its own methods for reporting which includes reviewing a patient's prior medical records and informing family members before releasing any figures.",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "HOW DANGEROUS IS THE VIRUS?",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": null,
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "If someone contracts COVID-19, how likely is that person to die? At the start of the outbreak a lot of attention was focussed on comparing COVID-19's death rate to other known diseases. While this number is hugely important for us to grasp how concerned we should all be, it is easily miscalculated.\n\nEpidemiologists, who study health and diseases, have two measurements to calculate risk of death, the case-fatality-rate(CFR) and the infection-fatality-rate(IFR).",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "The case-fatality-rate (CFR), is the proportion of people who die out of those who test positive. If 100 people test positive and ten people die then this makes the CFR 10%. The big problem with this number is that unlike most other diseases that have ended, new COVID-19 cases and deaths are being reported every day.\n\nThis makes COVID-19's death rate a moving target.\n\nEvery country has its own death rate. Italy's case-fatality-rate is around 12% while Germany is 1%. The virus itself is not more potent in Italy but rather the differences can be explained by how rigorously countries are testing and counting the number of infections and deaths. A country's age demographic and healthcare infrastructure have shown to play a role in determining this number.",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "The infection-fatality-rate (IFR) which is the proportion of people who die out of the actual number of people who were infected. If 1000 people actually have Covid-19 and only 100 of those test positive, then if ten people were to die the (IFR) would be 1% - much less than before but still higher than the seasonal flu.\n\nThe infection-fatality-rate is the fatality rate most of us are actually looking for.\n\nAs several reports have suggested, COVID-19's infection-fatality-rate is probably lower than initially estimated mainly due to many virus cases going undiagnosed.",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "CONFIRMED RECOVERIES",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": null,
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "The overwhelming majority of people who contract COVID-19 get better. While this number may seem quite low compared to the number of confirmed cases, according the WHO, the virus typically lasts around two weeks for mild cases and three to six weeks for serious cases. \n\nIt's important to remember that most coronavirus cases are mild.\n\nKeeping an eye on recoveries should help avoid unnecessary global panic and help individuals better understand the risks to themselves and their community.\n\nThere is a lot of uncertainty in calculating this figure. So much so that Johns Hopkins University temporarily suspend its reporting of recovered cases citing \"no reliable data source reporting recovered cases for many countries, such as the US”, before resuming its tally a few days later. https://github.com/CSSEGISandData/COVID-19/issues/1250",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "CONFIRMED ACTIVE CASES",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "The number of people who are still infected",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "If you want to know how many people are currently infected you need to take the number of confirmed cases and subtract those people who have recovered or died from the virus.\n\nEven if a country currently has a low number of confirmed cases, it's important to keep in mind that most countries show very similar traits in how the disease spread. Initially the numbers may seem small but once again due to the virus' exponential nature these figures multiply quickly.\n\nIn an ideal situation, extrapolating patterns from countries with early outbreaks including China, South Korea and Italy would help other countries inform their respective response strategies. The problem is that especially in the cases of China, official figures have been heavily criticized for underreporting.",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "THE LAG EFFECT",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  },
  {
    "home": null,
    "data1": "What we’re observing today is a result of what actions were taken a few weeks ago.\r\nA reduction in infections today should lead to fewer deaths weeks from now.\r\r",
    "data2": null,
    "datac": null,
    "data2q": null,
    "data3": null,
    "data4": null,
    "data5": null
  }
]
export default Database